import React, { useState } from "react";

const ConfirmModal = (props) => {
  const { onClose, message, title, handleDelete } = props;
  const [loader, setLoader] = useState(false);

  const handleDeleteApi = async () => {
    setLoader(true);
    await handleDelete();
    setLoader(false);
  };

  return (
    <>
      <div
        className="modal custom-modal fade bank-details show"
        id="add_items"
        role="dialog"
        aria-modal="true"
        style={{
          display: "block",
          background: "rgb(0 0 0 / 50%)",
        }}
      >
        <form action="">
          <div className="modal-dialog modal-dialog-centered modal-md">
            <div className="modal-content">
              <div className="modal-header">
                <div className="form-header text-start mb-0">
                  <h4 className="mb-0">{title}</h4>
                </div>
                <button
                  type="button"
                  className="close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={() => onClose()}
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="bank-inner-details">
                  <div className="row">
                    <div className="col-lg-12 col-md-12">{message}</div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <div className="bank-details-btn">
                  <button
                    data-bs-dismiss="modal"
                    className="btn bank-cancel-btn me-2"
                    onClick={() => onClose()}
                    disabled={loader}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="btn bank-save-btn"
                    onClick={handleDeleteApi}
                    disabled={loader}
                  >
                    {loader ? "Loading..." : "Confirm"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </>
  );
};

export default ConfirmModal;
